import { call, fork, put, select, take } from 'redux-saga/effects';
import {ActionType} from "typesafe-actions";
import {ResponseType} from "../../api/util";
import { Action as NotifyAction } from '../../NotificationSystem';
import * as Action from "../actions";
import {makeBoardInvitationSelector} from "../selectors/boardInvitation";

type FlowAction = ActionType<typeof Action.Command.resendBoardInvitation>;

function* onResendBoardInvitation(action: FlowAction) {
    const boardInvitation = yield select(makeBoardInvitationSelector(action.payload.invitationId));

    if (boardInvitation) {
        const {response, error}: ResponseType = yield call(
            Action.Api.resendBoardInvitation,
            action.payload.invitationId
        );

        if (error) {
            yield put(NotifyAction.Command.error('Request Error', 'Could not resend board invitation'));
        }

        if (response) {
            yield put(NotifyAction.Command.info(
                'insp.board.notify.invitation_resend.success.title',
                'insp.board.notify.invitation_resend.success.msg'
            ));
        }

        yield put(Action.Event.boardInvitationResent(boardInvitation.resend()));
    }
}

export function* resendBoardInvitationFlow() {
    while (true) {
        const action: FlowAction = yield take([
            Action.Type.RESEND_BOARD_INVITATION,
        ]);

        yield fork(onResendBoardInvitation, action);
    }
}